import Tabs from "@web-ui/components/Tabs";

/**
 * Filter buttons: the kit's Tabs for narrowing a list (All, Active, Expiring...), keyed by a
 * string (the kit keys by number). For one choice among a few options inside a form, use the
 * Segmented control instead. Moved here from the provider console so every app's tables share it.
 */
const FilterButtons = <T extends string>({ items, value, onChange, label, showLabel, className }: { items: ReadonlyArray<{ id: T; label: string }>; value: T; onChange(next: T): void; label: string;
    /** Print the group's name before its buttons. Required when two groups sit side by side, or "All" in one reads as part of the other (owner 2026-10-13). */
    showLabel?: boolean; className?: string }) => {
    const options = items.map((item, index) => ({ id: index + 1, name: item.label }));
    const current = options[Math.max(0, items.findIndex((item) => item.id === value))];
    return (
        <div role="group" aria-label={label} className={`${showLabel ? "flex flex-wrap items-center gap-3" : ""} ${className || ""}`}>
            {showLabel ? <span className="text-caption text-t-secondary" aria-hidden="true">{label}</span> : null}
            <Tabs className="flex-wrap" items={options} value={current} setValue={(option) => onChange(items[option.id - 1].id)} />
        </div>
    );
};

export default FilterButtons;
